/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instructions_TitleInputs */



/**
* | output |
* | --- |
* | "Activation Instructions:" |
*
* @param {Login_Offline_Instructions_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instructions_title = /** @type {((inputs?: Login_Offline_Instructions_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instructions_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Instructions d'Activation :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivierungsanleitung:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Istruzioni per l'attivazione:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Инструкция по активации:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Instrucciones de activación:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活说明：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティベーション手順:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्रियण निर्देश:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Instruções de ativação:")
	return /** @type {LocalizedString} */ ("Activation Instructions:")
});